import { render } from "./JJModal.vue?vue&type=template&id=d822b7ec&scoped=true"
import script from "./JJModal.vue?vue&type=script&lang=js"
export * from "./JJModal.vue?vue&type=script&lang=js"

import "./JJModal.vue?vue&type=style&index=0&id=d822b7ec&scoped=true&lang=css"

import exportComponent from "/var/www/html/clientwebview/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d822b7ec"]])

export default __exports__